import React from "react";
import { useTranslation } from "react-i18next";
import { useColors } from "../../constants/Colors";
import StepWrapper from "./StepWrapper";
import {
  SignupStore,
  USERNAME_MAX_LENGTH,
  USERNAME_MIN_LENGTH,
} from "../../hooks/useSignupStore";

interface Props {
  store: SignupStore;
}

const NameStep: React.FC<Props> = ({ store }) => {
  const { t } = useTranslation();
  const { textNeutralDefault, textNeutralMuted } = useColors();

  const charCount = store.name.length;

  return (
    <StepWrapper
      title={t("signup.name.title") || "What's your name?"}
      subtitle={
        t("signup.name.subtitle") || "This is how other flatmates will see you"
      }
    >
      <div className="space-y-4">
        <input
          type="text"
          value={store.name}
          onChange={(e) => store.setName(e.target.value)}
          placeholder={t("signup.name.placeholder") || "Enter your name"}
          maxLength={USERNAME_MAX_LENGTH}
          className="cf-input-boxed text-lg text-center"
          style={{ color: textNeutralDefault }}
          autoFocus
        />
        <div
          className="flex justify-center gap-4 text-sm"
          style={{ color: textNeutralMuted }}
        >
          {charCount < USERNAME_MIN_LENGTH && (
            <span>
              {`${
                t("signup.name.min_chars") || "Minimum"
              } ${USERNAME_MIN_LENGTH} ${t("characters") || "characters"}`}
            </span>
          )}
          <span>
            {charCount}/{USERNAME_MAX_LENGTH}
          </span>
        </div>
      </div>
    </StepWrapper>
  );
};

export default NameStep;
